export const SHOW_PERMISSIONS_EMAIL_BANNER = 'SHOW_PERMISSIONS_EMAIL_BANNER';
export const HIDE_PERMISSIONS_EMAIL_BANNER = 'HIDE_PERMISSIONS_EMAIL_BANNER';
export const SET_STEP_PERMISSIONS_EMAIL_BANNER = 'SET_STEP_PERMISSIONS_EMAIL_BANNER';



// WEBPACK FOOTER //
// ./app/Alerts/permissionsEmailBanner/actionTypes.js